import React from 'react';
import PropTypes from 'prop-types';

const GAPrefillModal = ({ productName, gaRequestNumber, skiRelease, onConfirm, onDismiss }) => (
  <div className="bc-draft-modal-overlay">
    <div className="bc-draft-modal">
      <h3 className="bc-draft-modal__title">GPR GA Request Found</h3>
      <p className="bc-draft-modal__message">
        A GPR GA request (<strong>{gaRequestNumber}</strong>) already exists for{' '}
        <strong>{productName}</strong>
        {skiRelease ? ` (${skiRelease})` : ''}.
      </p>
      <p className="bc-draft-modal__message">
        Would you like to pre-fill the matching fields in this SalesOps request from the GA request?
      </p>
      <div className="bc-draft-modal__actions">
        <button className="bc-draft-modal__btn bc-draft-modal__btn--primary" onClick={onConfirm}>
          Yes, pre-fill fields
        </button>
        <button className="bc-draft-modal__btn bc-draft-modal__btn--secondary" onClick={onDismiss}>
          No, start blank
        </button>
      </div>
    </div>
  </div>
);

GAPrefillModal.propTypes = {
  productName: PropTypes.string.isRequired,
  gaRequestNumber: PropTypes.string.isRequired,
  skiRelease: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

GAPrefillModal.defaultProps = {
  skiRelease: null,
};

export default GAPrefillModal;
